import { isMobile } from 'react-device-detect';
import { RefObject } from 'react';

export const HEADER_OFFSET = 85;

export const scrollToSelectElement = () => {
  const selectElement = document.querySelector('.ant-select');
  if (selectElement) {
    const elementPosition = selectElement.getBoundingClientRect().top;
    const offsetPosition = elementPosition + window.pageYOffset - HEADER_OFFSET;

    window.scrollTo({
      top: offsetPosition,
      behavior: 'smooth',
    });

    return offsetPosition;
  }
  return null;
};

export const handleMobileScrollToForm = (formRef: RefObject<HTMLDivElement>) => {
  if (isMobile) {
    scrollToSelectElement();
  } else {
    if (formRef && formRef.current) {
      formRef.current.scrollIntoView({ behavior: 'smooth' });
    }
  }
};
